import { get } from '@ebay/presence-ui/lib/object-helpers';
import { getGlobals } from '@ebay/presence-ui/lib/global-variables';
import StrTabList from '../str-tablist/component';

export default class {
    get tabs() {
        const tabs = get(this.input, 'page.modules.TABS_MODULE.tabs', []);
        // Add panelId to each tab
        tabs.forEach(tab => {
            StrTabList.addTabProperties(tab);
        });
        return tabs;
    }
    get shopHeader() {
        return {
            searchModule: get(this.input, 'page.modules.SEARCH_THE_STORE_MODULE', null),
            categoryModule: get(this.input, 'page.modules.STORE_CATEGORIES_MODULE', null),
            shipLocationModule: get(this.input, 'page.modules.SHIPPING_DESTINATION_MODULE', null)
        };
    }
    get spinner() {
        return get(this.input, 'page.modules.LOADING_SPINNER_MODULE');
    }
    isShopTab(idx) {
        return getGlobals().shopTabIndexes?.indexOf(`tab${idx}`) !== -1;
    }
    onCreate(input) {
        this.input = input;
        this.state = {
            selectedTabIndex: 0
        };
    }
    onInput(input) {
        this.input = input;
    }
    onMount() {
        document.addEventListener('str-tab-change-event', (evt) => {
            const panelId = evt.detail.panelId;
            if (typeof panelId !== 'undefined') {
                this.state.selectedTabIndex = this.tabs.findIndex(tab => tab.panelId === panelId);
            }
        });
    }
}
